import IGlassArea from 'components/interfaces/IGlassArea';

import getDefaultGlass from './getDefaultGlass';

const getDefaultGlassArea = (): IGlassArea => ({
  glasses: [getDefaultGlass()],
  name: '',
});

export default getDefaultGlassArea;
